import {
  Button,
  CircularProgress,
  FormLabel,
  makeStyles,
  Typography
} from '@material-ui/core'
import DateRangeIcon from '@material-ui/icons/DateRange'
import i18n from 'i18next'
import { FC } from 'react'
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux'
import {
  Field,
  reduxForm,
  InjectedFormProps,
  change,
  formValueSelector
} from 'redux-form'
import {
  ReduxDatePicker,
  ReduxPhoneField
} from '../../components/FormInput/ReduxWrappers'
import { selectCreateApplication } from '../../selectors/applications'
import { StateInterface } from '../../types/states'
import { MyCheckboxes, MyInput, MyRadio, MyTextArea } from './Fields'
import { CheckboxField } from './Fields/CheckboxField'
import { stripSpaces } from '../../utils/validation/forms'
// ReduxTextField
// import logo from './logo.svg';
// const styles = require('./App.module.css')
const useStyles = makeStyles({
  App: {
    textAlign: 'center',
    maxWidth: '500px',
    padding: '0 20px',
    margin: '20px auto',
    '& label': {
      fontSize: '12px',
      fontWeight: '500',
      color: 'black'
    }
  },
  AppBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  button: {
    maxWidth: '200px',
    backgroundColor: '#94004A',
    padding: '5px 45px',
    color: 'white',
    borderRadius: '6px',
    textTransform: 'none',
    fontWeight: 'bold',
    '& div': {
      width: '20px !important',
      height: '20px !important'
    },
    '& svg': {
      color: 'white'
    },
    '&:hover': {
      backgroundColor: '#670033 !important',
      color: '#FFFFFF'
    }
  },
  errorMessage: {
    fontSize: '0.75rem',
    marginTop: '5px'
  },
  black: {
    color: 'rgb(102, 102, 102) !important',
    display: 'block',
    lineHeight: '14px',
    margin: '0 0 5px 0'
  },
  phoneInput: {
    textAlign: 'left',
    '& .react-tel-input': {
      backgroundColor: 'rgb(243, 243, 243) !important',
      minHeight: '18px',
      borderRadius: '6px !important',
      fontSize: '13px',
      border: '1px solid rgb(232, 232, 232)',
      '&::after': {
        content: 'none !important'
      },
      '&::before': {
        content: 'none !important'
      },
      '&:hover': {
        marginBottom: '1px'
      },
      '& .special-label': {
        background: 'transparent',
        color: 'black',
        fontSize: '12px',
        fontWeight: '500',
        top: '-20px',
        fontFamily: 'CircularRegular'
      },
      '& input': {
        position: 'relative',
        zIndex: 2,
        background: 'transparent',
        fontFamily: 'CircularRegular'
      },
      '& .flag-dropdown': {
        zIndex: 2,
        background: 'transparent !important',
        backgroundColor: 'transparent !important',
        '& .selected-flag': {
          background: 'transparent !important',
          backgroundColor: 'transparent !important',
          '& .flag': {
            transform: 'scale(1.2) translateY(-1px)',
            '& .arrow': {
              transform: 'scale(1)'
            }
          }
        }
      }
    }
  },
  superLikeBox: {
    backgroundColor: '#FBF6EE',
    borderRadius: '10px',
    padding: '12px 16px',
    marginBottom: '12px',
    border: '1px solid #F1D9C5'
  },
  superLikeTitle: {
    display: 'block',
    color: '#1D1C1D',
    fontWeight: 700,
    fontSize: '13px',
    marginBottom: '2px'
  },
  superLikeDescription: {
    color: 'rgb(102, 102, 102)',
    fontSize: '12px',
    lineHeight: 1.4
  },
  checkboxIndented: {
    marginLeft: '16px',
    marginTop: '-10px'
  },
  datePicker: {
    position: 'relative',
    width: '100%',
    textAlign: 'left',
    '& > label': {
      fontFamily: 'CircularRegular',
      display: 'inline-block',
      paddingBottom: '0.5rem'
    },
    '& .MuiInput-underline': {
      margin: '0',
      '&::after': {
        content: 'none !important'
      },
      '&::before': {
        content: 'none !important'
      }
    },
    '& > svg': {
      display: 'inline-block',
      height: '1rem',
      width: '1rem',
      content: '""',
      background: 'transparent',
      color: 'gray',
      position: 'absolute',
      top: '2rem',
      left: '10px',
      zIndex: '15',
      cursor: 'pointer',
      pointerEvents: 'none'
    },
    '& .MuiTextField-root': {
      '& label': {
        zIndex: '15',
        display: 'none',
        position: 'absolute',
        margin: '0'
      },
      '& input': {
        fontSize: '13px',
        cursor: 'pointer',
        zIndex: '10',
        backgroundColor: `rgb(243, 243, 243)`,
        padding: '8px 8px 8px 32px',
        borderRadius: '6px',
        border: 'none',
        '&::after': {
          content: 'none !important'
        }
      }
    },
    '& .Mui-error': {
      fontSize: '11px',
      margin: '0',
      marginTop: '3px',
      textAlign: 'left',
      fontFamily: 'CircularRegular',
      'font-weight': '400',
      lineHeight: '1.66',
      letterSpacing: '0.03333em'
    }
  },
  formLabel: {
    display: 'inline-block',
    paddingBottom: '0.4rem'
  },
  backButton: {
    textTransform: 'unset' as const,
    padding: '5px 45px'
  },
  firstStepTitle: {
    textAlign: 'center',
    color: '#141414',
    fontWeight: 600,
    marginBottom: '0.5rem',
    margin: 'auto',
    '@media(max-width: 959px)': {
      fontSize: '1.2rem'
    }
  },
  fistStepButton: {
    minWidth: '184px',
    maxWidth: '290px',
    margin: 'auto',
    marginTop: '1rem'
  }
})

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface StateProps {
  formValues: any
  loading: boolean
  _error: string | null
}

interface DispatchProps {
  updateLivelihood: (value: string[]) => void
  updateSpouseLivelihood: (value: string[]) => void
}
interface OwnProps {
  // message: string;
  step: number
  back: () => void
}

interface IProps extends StateProps, DispatchProps, OwnProps { }

interface IPhoneField {
  phone: string | undefined
  countryDialCode: string | undefined
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IApplication {
  phone: IPhoneField
  firstName: string
  availabilities: any
  // lastName: string;
}

const genderOptions = ['woman', 'man', 'noAnswer']

const ageOptions = ['under18', '18-21', '22-29', '30-39', '40-54', '+55']
// const movingAboutOptions = ['thisMonth', 'nextMonth', '15days', 'firstDay']
const movingWithOptions = ['alone', 'asCouple', 'asFamily', 'asGroup']
const petsOptions = ['none', 'cat', 'dog', 'myAnswer']
const lifeSituationOptions = [
  'studying',
  'working',
  'jobSeeker',
  'pension',
  'myAnswer'
]

/*
const livelihoodOptions = [
  // extra for working
  'stockDividendIncome', // Stock dividend income
  'kelaBenefits', // Kela benefits
  // extra for jobSeeker
  'earningsRelatedBenefits', //Earnings-related benefits
  'workTrial', // Work trial
  'onCallWork', // On call work
  // extra for pension
  'rehabilitationSupport', // Rehabilitation support
  'pension', // Pension
  // extra for myAnswer
  'laborMarket', // Labor market
  'startupGrant', // Startup grant
  'maternityLeave', // Maternity leave

  'studentGrants',
  'studentLoan',
  'partTimeJob',
  'savings',
  'permanentJob',
  'myAnswer'
]
*/

// function getLivelihoodOptions(lifeSituation: string): string[] {
function getLHOptions(lifeSituation: string): string[] {
  switch (lifeSituation) {
    case 'studying':
      return [
        'studentGrants', // 'Student aid',
        'studentLoan', // Student loan
        'partTimeJob', // Part time job
        'savings', // Personal savings
        'permanentJob', // Full-time job
        'myAnswer' // Open answer
      ]
    case 'working':
      return [
        'permanentJob',
        'partTimeJob',
        'savings',
        'stockDividendIncome',
        'kelaBenefits',
        'myAnswer'
      ]
    case 'jobSeeker':
      return [
        'earningsRelatedBenefits',
        'workTrial',
        'onCallWork',
        'kelaBenefits',
        'savings',
        'myAnswer'
      ]
    case 'pension':
      return [
        'rehabilitationSupport',
        'pension',
        'kelaBenefits',
        'onCallWork',
        'savings',
        'myAnswer'
      ]
    case 'myAnswer':
      return [
        'rehabilitationSupport',
        'laborMarket',
        'kelaBenefits',
        'startupGrant',
        'maternityLeave',
        'myAnswer'
      ]
    default:
      return []
  }
}

const depositPaymentMethodOptions = [
  'money',
  'kelaObligation',
  'securityAccount',
  'iggloRentalGuarantee',
  'myAnswer'
]
const creditStatusOptions = ['good', 'bad']
const guarantorOptions = ['yes', 'no']
const rentalDebtsOptions = ['no', 'yes']

const t = (key: string, data?: any) => i18n.t(`newApplication.${key}`, data)

const required = (value?: string) =>
  value ? undefined : i18n.t('validation.required')

const phoneRequired = (value?: IPhoneField) => {
  if (value?.phone?.length === 3) {
    return i18n.t('validation.required')
  } else return undefined
}
const minPhoneLength = (value?: IPhoneField) => {
  if (value && value.phone && value.phone.length >= 10) {
    return undefined
  } else {
    return i18n.t('validation.invalidPhoneNumber')
  }
}
const noZeroAfterCode = (value?: IPhoneField) => {
  if (
    value &&
    value.phone &&
    (value.phone.startsWith(`${value.countryDialCode}0`) ||
      value.phone.startsWith(`+${value.countryDialCode}0`))
  ) {
    return i18n.t('validation.phoneNumber')
  } else {
    return undefined
  }
}
export const isOneAdult: (values: {
  movingWith: string
  movingWithAmount: string
}) => boolean = (values) =>
    values.movingWith === 'alone' || values.movingWithAmount === '1'

const Form: FC<InjectedFormProps<IApplication, IProps> & IProps> = (props) => {
  const {
    handleSubmit,
    formValues,
    updateLivelihood,
    updateSpouseLivelihood,
    step,
    back
  } = props

  const styles = useStyles()
  // const renderDatePicker = (props: any) => <ReduxStaticDatePicker {...props} />

  return (
    <form onSubmit={handleSubmit} style={{ width: '100%' }}>
      <div className={styles.App}>
        {/* PICKING TIME  */}
        {/* {step === 4 && (
          <Grid container spacing={1}>
            <Typography variant='h5' className={styles.firstStepTitle}>
              {t('visitDateTime')}
            </Typography>
            <Typography
              variant='subtitle1'
              style={{ textAlign: 'center', color: 'gray', margin: 'auto' }}
            >
              {t('chooseAtLeast')}
            </Typography>
            <FieldArray
              name='availabilities'
              component={AvailabilitiesField}
              renderDatePicker={renderDatePicker}
              formValues={formValues}
              validate={[validateMinAvailabilitiesLength(2)]}
            />
          </Grid>
        )} */}
        {step === 0 && (
          <div className={styles.AppBlock}>
            <Typography variant='h5' style={{ textAlign: 'left' }}>
              {t('tellTheLandlordAboutYourself')}
            </Typography>
            <div style={{ display: 'flex' }}>
              <div
                style={{
                  width: '50%',
                  textAlign: 'left',
                  paddingRight: '10px'
                }}
              >
                <Field
                  label={t('firstName')}
                  name='firstName'
                  component={MyInput}
                  type='text'
                  style={{ width: '100%' }}
                  validate={[required]}
                />
              </div>
              <div
                style={{ width: '50%', textAlign: 'left', paddingLeft: '10px' }}
              >
                <Field
                  label={t('lastName')}
                  name='lastName'
                  component={MyInput}
                  type='text'
                  style={{ width: '100%' }}
                  validate={[required]}
                />
              </div>
            </div>
            <div style={{ textAlign: 'left' }}>
                <Field
                  label={t('email')}
                  name='email'
                  component={MyInput}
                  type='email'
                  style={{ width: '100%' }}
                  normalize={stripSpaces}
                  validate={[required]}
                />
            </div>
            <div className={styles.phoneInput}>
              <Field
                label={t('phone')}
                name='phone'
                component={ReduxPhoneField}
                placeholder='501234567'
                type='phone'
                style={{ width: '100%' }}
                validate={[phoneRequired, noZeroAfterCode, minPhoneLength]}
                isError={true}
              />
            </div>
            <div style={{ textAlign: 'left' }}>
              <Field
                label={t('gender')}
                name='gender'
                component={MyRadio}
                items={genderOptions.map((key) => [
                  key,
                  t(`genderOptions.${key}`)
                ])}
                validate={[required]}
              />
            </div>
            <div style={{ textAlign: 'left' }}>
              <Field
                label={t('age')}
                name='age'
                component={MyRadio}
                items={ageOptions.map((key) => [key, t(`ageOptions.${key}`)])}
                validate={[required]}
              />
            </div>
          </div>
        )}
        {step === 1 && (
          <div className={styles.AppBlock}>
            <Typography variant='h5' style={{ textAlign: 'left' }}>
              {t('tellTheLandlordAboutYourself')}
            </Typography>
            {/*
            <div style={{ textAlign: 'left' }}>
              <Field
                label={t('movingAbout')}
                name='movingAbout'
                component={MyRadio}
                items={movingAboutOptions.map((key) => [
                  key,
                  t(`movingAboutOptions.${key}`)
                ])}
                validate={[required]}
              />
            </div>
            */}
            {(true || formValues.movingAbout === 'nextMonth') && (
              <div className={styles.datePicker}>
                <label>{t('movingAbout')}</label>
                <DateRangeIcon />
                <Field
                  label={t('movingAbout')}
                  name='readyForMoveDate'
                  component={ReduxDatePicker}
                  type='text'
                  style={{ width: '100%' }}
                  validate={[required]}
                />
              </div>
            )}
            <div style={{ textAlign: 'left' }}>
              <Field
                label={t('movingWith')}
                name='movingWith'
                component={MyRadio}
                items={movingWithOptions.map((key) => [
                  key,
                  t(`movingWithOptions.${key}`)
                ])}
                validate={[required]}
              />
            </div>
            {(formValues.movingWith === 'asGroup' || formValues.movingWith === 'asFamily') && (
              <div style={{ textAlign: 'left' }}>
                <Field
                  label={t('movingWithAmount')}
                  name='movingWithAmount'
                  component={MyRadio}
                  items={[
                    ['1', '1'],
                    ['2', '2'],
                    ['3', '3'],
                    ['4', '4'],
                    ['5+', '5+']
                  ]}
                  validate={[required]}
                />
              </div>
            )}

            {formValues.movingWith === 'asFamily' && (
              <div style={{ textAlign: 'left' }}>
                <Field
                  label={t('movingWithChildrenAmount')}
                  name='movingWithChildrenAmount'
                  component={MyRadio}
                  items={[
                    ['1', '1'],
                    ['2', '2'],
                    ['3', '3'],
                    ['4', '4'],
                    ['5+', '5+']
                  ]}
                  validate={[required]}
                />
              </div>
            )}
            <div style={{ textAlign: 'left' }}>
              <Field
                label={t('pets')}
                name='pets' // Pet // pets & petType
                component={MyRadio}
                items={petsOptions.map((key) => [key, t(`petsOptions.${key}`)])}
                validate={[required]}
              />
            </div>
            {formValues.pets === 'myAnswer' && (
              <div style={{ textAlign: 'left' }}>
                <Field
                  name='petsCustom' // petType
                  component={MyTextArea}
                  style={{ width: '100%' }}
                  validate={[required]}
                />
              </div>
            )}
          </div>
        )}
        {step === 2 && (
          <div className={styles.AppBlock}>
            {/* ============== */}
            <Typography align='left'>
              {t('lifeSituationHeader')}{' '}
              <span
                style={{
                  fontSize: '0.8em',
                  color: 'gray',
                  fontWeight: 'normal'
                }}
              >
                {t('lifeSituationSubheader')}
              </span>
            </Typography>
            <div style={{ textAlign: 'left' }}>
              <Field
                label={t('lifeSituation')}
                name='lifeSituation'
                component={MyRadio}
                extraChange={() => {
                  updateLivelihood([])
                }}
                items={lifeSituationOptions.map((key) => [
                  key,
                  t(`lifeSituationOptions.${key}`)
                ])}
                validate={[required]}
              />
            </div>
            {formValues.lifeSituation === 'myAnswer' && (
              <div style={{ textAlign: 'left' }}>
                <Field
                  name='lifeSituationCustom'
                  component={MyTextArea}
                  style={{ width: '100%' }}
                  validate={[required]}
                />
              </div>
            )}
            {formValues.lifeSituation && (
              <div style={{ textAlign: 'left' }}>
                <FormLabel className={styles.formLabel}>
                  {t('livelihood')}
                </FormLabel>
                <br />
                <FormLabel className={styles.black}>
                  {t('livelihoodNotice')}
                </FormLabel>
                <Field
                  name='livelihood'
                  component={MyCheckboxes}
                  items={getLHOptions(formValues.lifeSituation).map((key) => [
                    key,
                    t(`livelihoodOptions.${key}`)
                  ])}
                  validate={[required]}
                />
                {Array.isArray(formValues.livelihood) &&
                  formValues.livelihood.includes('myAnswer') && (
                    <div>
                      <Field
                        name='livelihoodCustom'
                        component={MyTextArea}
                        style={{ width: '100%' }}
                        validate={[required]}
                      />
                    </div>
                  )}
              </div>
            )}
            <div style={{ textAlign: 'left' }}>
              <Field
                label={t('depositPaymentMethod')}
                name='depositPaymentMethod'
                component={MyRadio}
                items={depositPaymentMethodOptions.map((key) => [
                  key,
                  t(`depositPaymentMethodOptions.${key}`)
                ])}
                validate={[required]}
              />
            </div>
            {formValues.depositPaymentMethod === 'myAnswer' && (
              <div style={{ textAlign: 'left' }}>
                <Field
                  name='depositPaymentMethodCustom'
                  component={MyTextArea}
                  style={{ width: '100%' }}
                  validate={[required]}
                />
              </div>
            )}
            {/* not implemented */}
            <div style={{ textAlign: 'left' }}>
              <FormLabel className={styles.formLabel}>
                {t('creditStatus')}
              </FormLabel>
              <br />
              <FormLabel className={styles.black}>
                {t('creditStatusNotice')}
              </FormLabel>
              {/* <br /> */}
              <Field
                name='creditStatus'
                component={MyRadio}
                items={creditStatusOptions.map((key) => [
                  key,
                  t(`creditStatusOptions.${key}`)
                ])}
                validate={[required]}
              />
            </div>

            {formValues &&
              (formValues.creditStatus === 'bad') && (
                <div style={{ textAlign: 'left' }}>
                  <FormLabel className={styles.formLabel}>
                    {t('rentalDebts')}
                  </FormLabel>
                  <br />
                  <Field
                    name='rentalDebts'
                    component={MyRadio}
                    items={rentalDebtsOptions.map((key) => [
                      key,
                      t(`rentalDebtsOptions.${key}`)
                    ])}
                    validate={[required]}
                  />
                </div>
              )}


            {formValues &&
              (formValues.lifeSituation === 'jobSeeker' ||
                formValues.creditStatus === 'bad' ||
                formValues.depositPaymentMethod === 'kelaObligation') && (
                <div style={{ textAlign: 'left' }}>
                  <Field
                    label={t('guarantor')}
                    name='guarantorPossible'
                    component={MyRadio}
                    items={guarantorOptions.map((key) => [
                      key,
                      t(`guarantorOptions.${key}`)
                    ])}
                    validate={[required]}
                  />
                </div>
              )}
          </div>
        )}
        {step === 3 && (
          <div className={styles.AppBlock}>
            <Typography align='left'>
              {t('lifeSituationHeader')}{' '}
              <span
                style={{
                  fontSize: '0.8em',
                  color: '#F41211',
                  fontWeight: 'normal'
                }}
              >
                {formValues.movingWith === 'asGroup'
                  ? '2. ' + t('otherApplicantSubheader')
                  : t('spouseSubheader')}
              </span>
            </Typography>
            {/* not implemented */}
            <div style={{ textAlign: 'left' }}>
              <Field
                label={t('spouseLifeSituation')}
                name='spouseLifeSituation'
                component={MyRadio}
                extraChange={() => {
                  updateSpouseLivelihood([])
                }}
                items={lifeSituationOptions.map((key) => [
                  key,
                  t(`lifeSituationOptions.${key}`)
                ])}
                validate={[required]}
              />
            </div>
            {formValues.spouseLifeSituation === 'myAnswer' && (
              <div style={{ textAlign: 'left' }}>
                <Field
                  name='spouseLifeSituationCustom'
                  component={MyTextArea}
                  style={{ width: '100%' }}
                  validate={[required]}
                />
              </div>
            )}
            {formValues.spouseLivelihood && (
              <div style={{ textAlign: 'left' }}>
                <FormLabel className={styles.formLabel}>
                  {t('livelihood')}
                </FormLabel>
                <br />
                <FormLabel className={styles.black}>
                  {t('livelihoodNotice')}
                </FormLabel>
                <Field
                  name='spouseLivelihood'
                  component={MyCheckboxes}
                  items={(() => {
                    const list = getLHOptions(formValues.spouseLifeSituation)
                    return list.map((key) => [
                      key,
                      t(`livelihoodOptions.${key}`)
                    ])
                  })()}
                  validate={[required]}
                />
                {Array.isArray(formValues.spouseLivelihood) &&
                  formValues.spouseLivelihood.includes('myAnswer') && (
                    <div>
                      <Field
                        name='spouseLivelihoodCustom'
                        component={MyTextArea}
                        style={{ width: '100%' }}
                        validate={[required]}
                      />
                    </div>
                  )}
              </div>
            )}
            <div style={{ textAlign: 'left' }}>
              <FormLabel className={styles.formLabel}>
                {t('creditStatus')}
              </FormLabel>
              <br />
              <FormLabel className={styles.black}>
                {t('spouseCreditStatusNotice')}
              </FormLabel>
              <Field
                name='spouseCreditStatus'
                component={MyRadio}
                items={creditStatusOptions.map((key) => [
                  key,
                  t(`creditStatusOptions.${key}`)
                ])}
                validate={[required]}
              />
            </div>
            {formValues.spouseLifeSituation === 'jobSeeker' && (
              <div style={{ textAlign: 'left' }}>
                <Field
                  label={t('guarantor')}
                  name='spouseGuarantorPossible'
                  component={MyRadio}
                  items={guarantorOptions.map((key) => [
                    key,
                    t(`guarantorOptions.${key}`)
                  ])}
                  validate={[required]}
                />
              </div>
            )}
          </div>
        )}
        <div className={styles.AppBlock} style={{ paddingTop: '1rem' }}>
          <>
            {(step === 3 || (step === 2 && isOneAdult(formValues))) && (
              <>
                <div style={{ textAlign: 'left' }}>
                  <FormLabel className={styles.formLabel}>
                    {t('notes')}
                  </FormLabel>
                  <Field
                    name='notes'
                    component={MyTextArea}
                    style={{ width: '100%', height: '108px' }}
                  />
                </div>
                {/* <div style={{ textAlign: 'left' }}>
                  <FormLabel className={styles.formLabel}>
                    {t('picture.profilePicture')}
                  </FormLabel>
                  <Field
                    name='profilePicture'
                    component={ImageUploadButton}
                    uploadText={t('picture.upload')}
                    changeText={t('picture.change')}
                    saveText={t('picture.save')}
                    uploadErrorText={t('picture.uploadError')}
                    style={{ width: '100%', height: '36px' }}
                    //validate={[required]}
                  />
                </div> */}
                {/* SuperLike temporarily disabled
                <div className={styles.superLikeBox}>
                  <Field
                    label={
                      <div>
                        <div className={styles.superLikeTitle}>
                          {t('superLikeLabel')}
                        </div>
                        <div className={styles.superLikeDescription}>
                          {t('superLikeDescription')}
                        </div>
                      </div>
                    }
                    name='superLike'
                    component={CheckboxField}
                  />
                </div>
                */}
                <Field
                  label={
                    <>
                      {t('agreed')}{' '}
                      {/* <a
                        href='https://https://leea.fi/kayttoehdot/'
                        target='_blank'
                        rel='noreferrer'
                      >
                        {t('terms')}
                      </a>{' '}
                      {t('and')}{' '} */}
                      <a
                        href='https://leea.fi/tietosuojaseloste/'
                        target='_blank'
                        rel='noreferrer'
                      >
                        {t('privacyPolicy')}
                      </a>
                    </>
                  }
                  name='agreed'
                  component={CheckboxField}
                  validate={[required]}
                  className={styles.checkboxIndented}
                />
                <Field
                  label={t('contactInformationConsent')}
                  name='contactInformationConsent'
                  component={CheckboxField}
                  className={styles.checkboxIndented}
                />
              </>
            )}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
              {step > 0 && (
                <Button
                  className={styles.backButton}
                  variant='outlined'
                  onClick={() => {
                    back()
                  }}
                >
                  {t('back')}
                </Button>
              )}
              <Button
                fullWidth={step === 3}
                type='submit'
                className={`${styles.button} ${step === 0 ? styles.fistStepButton : ''
                  }`}
                disabled={Boolean(props.loading)}
              >
                {props.loading ? (
                  <CircularProgress size={10} color='secondary' />
                ) : step === 0 ||
                  step === 1 ||
                  (step === 2 && !isOneAdult(formValues)) ? (
                  i18n.t('general.continue')
                ) : (
                  <>{i18n.t('general.send')}</>
                )}
              </Button>
            </div>
            {props._error && (
              <Typography
                className={styles.errorMessage}
                align={step === 3 ? 'center' : 'left'}
                color='error'
                variant='body2'
              >
                {props._error}
              </Typography>
            )}
          </>
        </div>
      </div>
    </form>
  )
}

const selector = formValueSelector('newApplication')

const mapState: MapStateToProps<StateProps, OwnProps, StateInterface> = (
  state
) => ({
  loading: selectCreateApplication(state).loading,
  _error: selectCreateApplication(state).error,
  formValues:
    selector(
      state,
      'availabilities',
      'movingAbout',
      'movingWith',
      'movingWithAmount',
      'pets',
      'livelihood',
      'lifeSituation',
      'spouseLivelihood',
      'depositPaymentMethod',
      'spouseLifeSituation',
      'creditStatus',
      'rentalDebts',
      'profilePicture'
    ) || {}
})

const mapActions: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch) => {
  return {
    updateSpouseLivelihood: (value) =>
      dispatch(change('newApplication', 'spouseLivelihood', value)),
    updateLivelihood: (value) =>
      dispatch(change('newApplication', 'livelihood', value))
  }
}

const NewApplicationForm = connect<
  StateProps,
  DispatchProps,
  OwnProps,
  StateInterface
>(
  mapState,
  mapActions
)(
  reduxForm<IApplication, IProps>({
    // a unique name for the form
    form: 'newApplication',
    forceUnregisterOnUnmount: false,
    enableReinitialize: true
  })(Form)
)

export default NewApplicationForm
